export default __webpack_public_path__ + "static/media/casbah.6bcbe838.svg";